import { Address, Network } from 'nftx.js';

export const V2_API_URL = 'https://api-v4.nftx.xyz';

export const V2_AUTH =
  process.env.NODE_ENV === 'production'
    ? '01GF46CVDK4TQ35330G3P6M6DC'
    : '01GF45ZJ6MWWKYVYV167H9P9KN';

export const NFTX_INVENTORY_STAKING = {
  [Network.Mainnet]: '0x3E135c3E981fAe3383A5aE0d323860a34CfAB893' as Address,
  [Network.Arbitrum]: '0x1A2C03ABD4Af7C87d8b4d5aD39b56fa98E8C4Cc6' as Address,
};

export const NFTX_LP_STAKING = {
  [Network.Mainnet]: '0x688c3E4658B5367da06fd629E41879beaB538E37' as Address,
  [Network.Arbitrum]: '0x5326A720f76CFbDfE9e18fA618C3a3f7AbDF3934' as Address,
};

export const SUSHISWAP_ROUTER = {
  [Network.Mainnet]: '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F' as Address,
  [Network.Arbitrum]: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506' as Address,
};

export const MIGRATOR_ZAP = {
  [Network.Mainnet]: '0x089610Fb04c34C014B4B391f4eCEFAef94E98CEc' as Address,
  [Network.Sepolia]: '0x802aaAE9395aA5f7F414B237D1bb13d4f58f43c7' as Address,
  [Network.Arbitrum]: '0x6E1537eD56f52414f0182FaebF79A5fB2Ad2CABd' as Address,
};
